// extracted by mini-css-extract-plugin
export var dataCell = "_pl-2";
export var dataRow = "_pl-0";
export var headerRow = "_pl-1";